// Misma regla que API/src/helpers/documentosProveedor.js: `obligatorio` de
// DOCUMENTOS_PROVEEDOR es un dato que se compara, nunca código que se ejecuta.
const CAMPO_VALIDO = /^[A-Za-z_][A-Za-z0-9_]*$/;
const esValorSimple = (valor) => ["string", "number", "boolean"].includes(typeof valor);

// Formato heredado, p. ej. "return val.tipoProveedor === 'Jurídica'": se
// interpreta como comparación sin ejecutarlo.
const CONDICION_LEGACY = /^\s*return\s+val\.([A-Za-z_][A-Za-z0-9_]*)\s*===\s*(['"])([^'"]*)\2\s*;?\s*$/;

/**
 * Normaliza `obligatorio` a true / false o { campo, igual }.
 * Un valor no reconocido se considera obligatorio.
 */
export const normalizarObligatorio = (obligatorio) => {
  if (obligatorio === undefined || obligatorio === null || obligatorio === false) return false;
  if (obligatorio === true) return true;

  if (typeof obligatorio === "string") {
    const legacy = obligatorio.match(CONDICION_LEGACY);
    return legacy ? { campo: legacy[1], igual: legacy[3] } : true;
  }

  if (
    typeof obligatorio === "object" &&
    typeof obligatorio.campo === "string" &&
    CAMPO_VALIDO.test(obligatorio.campo) &&
    esValorSimple(obligatorio.igual)
  ) {
    return { campo: obligatorio.campo, igual: obligatorio.igual };
  }

  return true;
};

export const esDocumentoObligatorio = (documento, proveedor) => {
  const regla = normalizarObligatorio(documento?.obligatorio);
  if (typeof regla === "boolean") return regla;
  if (!proveedor) return true;
  return proveedor[regla.campo] === regla.igual;
};
